module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel_contrate_melia.723e71df.png";